module.exports = __webpack_public_path__ + "img/icon11.c0c9afdd.png";